module.exports = __webpack_public_path__ + "img/website.faaff1a3.svg";